import React, { useEffect, useState, useContext } from 'react';
import { connect } from 'react-redux';
import { Accordion, Card, useAccordionToggle } from 'react-bootstrap';
import AccordionContext from 'react-bootstrap/AccordionContext';
import Icon from '@mdi/react';
import { mdiChevronDown, mdiChevronRight, mdiLockOutline } from '@mdi/js';
import HeadingsStack from './HeadingsStack';

// Styles
const styleNoData = {
  backgroundColor: 'var(--theme-page-background-alternate)!important',
  marginBottom: '10px',
};
const styleData = {
  fontSize: '0.7rem',
  backgroundColor: 'var(--theme-page-background-alternate)!important',
  borderBottom: 'unset',
  marginBottom: '10px',
};
const LayerStackTitle = {
  fontWeight: '400',
  fontSize: '12px',
  textTransform: 'uppercase',
  lineHeight: '14px',
};
const unavaliableTitle = {
  ...LayerStackTitle,
  color: '#DDDDDD',
};
const bulletStyle = {
  color: '#b7b7b7',
  fontSize: '30px',
  display: 'inline-block',
  marginRight: '8px',
};
const bulletStyleActive = {
  color: 'var(--theme-primary)',
  fontSize: '30px',
  display: 'inline-block',
  marginRight: '8px',
};
const ueLayerChevron = {
  backgroundColor: '#2B3536',
  borderRadius: '4px',
  padding: '8px',
};

// CustomToggle component
const CustomToggle = ({ eventKey, callback, title, notempty, isActive }) => {
  const currentEventKey = useContext(AccordionContext);
  const decoratedOnClick = useAccordionToggle(eventKey, () => {
    if (callback) callback(eventKey);
  });
  const isCurrent = currentEventKey === eventKey;

  const headerStyle = isCurrent
    ? { color: 'var(--theme-primary)', backgroundColor: 'var(--theme-page-background-alternate)', padding: '0.5rem 1rem', borderRadius: '6px' }
    : { backgroundColor: 'var(--theme-page-background-alternate)', padding: '0.5rem 1rem', borderRadius: '6px' };

  return (
    <Card.Header style={headerStyle} onClick={decoratedOnClick}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={isActive ? bulletStyleActive : bulletStyle}>&bull;</span>
          <span style={notempty ? LayerStackTitle : unavaliableTitle}>{title || 'Untitled'}</span>
        </div>
        <div style={ueLayerChevron}>
          {notempty ? (
            isCurrent ? <Icon path={mdiChevronDown} size={0.6} color="#FFF" /> : <Icon path={mdiChevronRight} size={0.6} color="#FFF" />
          ) : (
            <Icon path={mdiLockOutline} size={0.6} color="#FFF" />
          )}
        </div>
      </div>
    </Card.Header>
  );
};

// ThemasStack component
const ThemasStack = (props) => {
  // 1. Normalize props
  const safeData = Array.isArray(props.data) ? props.data : [];
  const safeLayers = Array.isArray(props.layers_stack) ? props.layers_stack : [];

  // Local state for bullet color
  const [anyLayerActive, setAnyLayerActive] = useState(false);

  // Determine if any layer is active
  useEffect(() => {
    const allLayerRefs = safeData
      .flatMap(group => {
        const headings = Array.isArray(group) ? group : [group];
        return headings
          .filter(h => h && Array.isArray(h.layers_stack))
          .flatMap(h =>
            h.layers_stack
              .filter(ly => ly && ly.gs_thematique && ly.gs_layer)
              .map(ly => `${ly.gs_thematique.trim()}:${ly.gs_layer.trim()}`)
          );
      });
    setAnyLayerActive(allLayerRefs.some(ref => safeLayers.includes(ref)));
  }, [props.data, props.layers_stack]);

  // Check if there is data to display
  const notempty =
    safeData.length > 0 &&
    safeData.some(group => Array.isArray(group) ? group.length > 0 : !!group);

  const eventKey = notempty && props.refid ? props.refid : 'ban';

  return (
    <Card className="rounded ueThemeBackground" style={notempty ? styleData : styleNoData}>
      <CustomToggle
        eventKey={eventKey}
        title={props.title}
        notempty={notempty}
        isActive={anyLayerActive}
      />
      <Accordion.Collapse eventKey={eventKey}>
        <Card.Body className="p-0" style={{ fontSize: '0.4rem', backgroundColor: 'var(--theme-page-background-alternate)' }}>
          {notempty && (
            <Accordion defaultActiveKey="Parcellaire">
              {safeData.flatMap((group, groupIdx) => {
                const headings = Array.isArray(group) ? group : [group];
                return headings
                  .filter(Boolean)
                  .map((heading, idx) => {
                    const key = heading.id || `heading-${groupIdx}-${idx}`;
                    return (
                      <HeadingsStack
                        key={key}
                        title={heading.rub_title || 'Untitled'}
                        refid={key}
                        data={Array.isArray(heading.layers_stack) ? heading.layers_stack : []}
                      />
                    );
                  });
              })}
            </Accordion>
          )}
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );
};

ThemasStack.defaultProps = {
  data: [],
  layers_stack: [],
  title: 'Untitled Group',
  refid: null,
};

const mapStateToProps = (state) => ({
  layers_stack: state.LayersReducer.layers_stack || [],
});

export default connect(mapStateToProps)(ThemasStack);
